import React from 'react';

export const PrivacyPolicy = () => {
  return (
    <>
      <nav id="menu" className="navbar navbar-default navbar-fixed-top">
        <div className="container">
          <div className="navbar-header">
            <button
              type="button"
              className="navbar-toggle collapsed"
              data-toggle="collapse"
              data-target="#legal-navbar"
            >
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
            </button>
            <a className="navbar-brand" href="/">
              Blackbyrd
            </a>
          </div>
          <div className="collapse navbar-collapse" id="legal-navbar">
            <ul className="nav navbar-nav navbar-right">
              <li>
                <a href="/">Home</a>
              </li>
              <li>
                <a href="/terms-and-conditions">Terms & Conditions</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <div className="legal-page">
        <div className="container">
          <div className="section-title">
            <h2>Privacy Policy</h2>
            <p>Last updated March 30, 2026</p>
          </div>
          <div className="legal-card">
            <h3>Overview</h3>
            <p>
              This Privacy Policy explains how Blackbyrd AI LLC ("Blackbyrd," "we," "our,"
              or "us") collects, uses, and shares information about you when you visit our
              website or use our Services. By using the Services, you agree to the
              collection and use of information as described in this policy.
            </p>

            <h3>Information We Collect</h3>
            <p>
              We collect information in the following ways:
            </p>
            <p>
              <strong>Information you provide.</strong> When you submit a form or otherwise
              contact us, you may provide your name, email address, phone number, business
              details, and message content.
            </p>
            <p>
              <strong>Automatic data.</strong> We may collect technical information such as
              IP address, browser type, device identifiers, referring pages, and usage
              data through logs and standard analytics.
            </p>
            <p>
              <strong>Cookies and similar technologies.</strong> We use cookies or similar
              technologies to improve site functionality, measure performance, and
              understand usage patterns. You can control cookies through your browser
              settings.
            </p>

            <h3>How We Use Information</h3>
            <p>
              We use information to:
            </p>
            <p>
              • Respond to your inquiries and provide support<br />
              • Provide and improve our Services and website experience<br />
              • Communicate with you about our offerings and updates<br />
              • Maintain security, prevent fraud, and enforce our Terms
            </p>

            <h3>SMS/Text Messaging</h3>
            <p>
              If you provide your phone number and consent to receive SMS/text messages
              from Blackbyrd AI LLC, the following applies:
            </p>
            <p>
              <strong>Types of messages.</strong> Depending on your consent selections, you
              may receive transactional messages (such as account alerts, appointment
              reminders, and service notifications) and/or marketing and promotional
              messages related to our Services.
            </p>
            <p>
              <strong>Message frequency.</strong> Message frequency may vary based on your
              interactions with us and the type of messages you have consented to receive.
            </p>
            <p>
              <strong>Costs.</strong> Message and data rates may apply depending on your
              mobile carrier plan.
            </p>
            <p>
              <strong>Opt-out.</strong> You may opt out of receiving SMS messages at any
              time by replying STOP to any message you receive from us. After opting out,
              you will receive a confirmation message and will no longer receive SMS
              messages from us unless you re-subscribe.
            </p>
            <p>
              <strong>Help.</strong> For help with SMS messages, reply HELP to any message
              or contact us at contact@blackbyrd.ai.
            </p>
            <p>
              <strong>No sharing with third parties.</strong> We do not share your phone
              number or SMS consent information with third parties or affiliates for
              marketing or promotional purposes. Your SMS consent and phone number data
              are shared only with our SMS service provider solely for the purpose of
              delivering the messages you have consented to receive.
            </p>

            <h3>How We Share Information</h3>
            <p>
              We may share information with:
            </p>
            <p>
              • Service providers that help us operate our business (e.g., hosting,
              analytics, and communications)<br />
              • Professional advisors such as accountants, attorneys, and insurers<br />
              • Law enforcement or regulators when required by law or to protect rights
            </p>
            <p>
              We do not sell personal information for money. We do not share your SMS
              consent or phone number information with third parties for their marketing
              purposes (except SMS service providers solely for message delivery). If our
              practices change, we will update this policy.
            </p>

            <h3>Data Retention</h3>
            <p>
              We retain personal information only as long as necessary to fulfill the
              purposes described in this policy, unless a longer retention period is
              required or permitted by law.
            </p>

            <h3>Data Security</h3>
            <p>
              We implement reasonable administrative, technical, and physical safeguards
              designed to protect your information. No system can be guaranteed to be
              100% secure, and we cannot guarantee absolute security.
            </p>

            <h3>Your Choices and Rights</h3>
            <p>
              You may request access to, correction of, or deletion of your personal
              information by contacting us. We may need to verify your identity before
              fulfilling a request. Certain legal or contractual obligations may limit
              what we can do.
            </p>

            <h3>International Users</h3>
            <p>
              If you access the Services from outside the United States, your information
              may be processed in the United States or other countries where our service
              providers operate.
            </p>

            <h3>Children's Privacy</h3>
            <p>
              The Services are not directed to children under 13, and we do not knowingly
              collect personal information from children.
            </p>

            <h3>Third-Party Sites</h3>
            <p>
              Our website may contain links to third-party sites. We are not responsible
              for their privacy practices, and we encourage you to review their policies.
            </p>

            <h3>Changes to This Policy</h3>
            <p>
              We may update this Privacy Policy from time to time. The "Last updated"
              date above indicates when changes were made.
            </p>

            <h3>Contact Us</h3>
            <p>
              If you have questions about this Privacy Policy, contact us at
              contact@blackbyrd.ai.
            </p>
          </div>
        </div>
      </div>

      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2026 Blackbyrd AI LLC.{' '}
            <a href="/terms-and-conditions">Terms & Conditions</a> |{' '}
            <a href="/privacy-policy">Privacy Policy</a>
          </p>
        </div>
      </div>
    </>
  );
};
